/** 输入建议类型（存于字段 selectContent，仅 fieldType=单行文本时生效） */
export const INPUT_SUGGEST_TYPE = {
  NONE: '',
  SCHOOL: 'school'
}

export const INPUT_SUGGEST_TYPE_OPTIONS = [
  { label: '无', value: INPUT_SUGGEST_TYPE.NONE },
  { label: '学校名称', value: INPUT_SUGGEST_TYPE.SCHOOL }
]

export const isInputSuggestEnabled = (field) =>
  String(field?.fieldType) === '2' && field?.selectContent === INPUT_SUGGEST_TYPE.SCHOOL

export const hasSchoolTagDisplay = (schoolTag) =>
  schoolTag != null && (
    (Array.isArray(schoolTag.tags) && schoolTag.tags.length > 0) ||
    (schoolTag.qsRank != null && schoolTag.qsRank !== '')
  )

export const formatQsRankText = (schoolTag) => {
  if (schoolTag?.qsRank == null || schoolTag.qsRank === '') {
    return ''
  }
  return `QS：${ schoolTag.qsRank }`
}
